import React, {useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ParserImage from "../ParserImage";
import axios from "axios";
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import SpinnerLoading from "../SpinnerLoading";

import "../assets/themify-icon/themify-icons.css";
import "../assets/simple-line-icon/simple-line-icons.css";
import "../assets/font-awesome/css/all.css";
import "../assets/elagent/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/main.css";
import "../assets/responsive.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "../assets/custom.css";
import "primereact/resources/themes/lara-light-cyan/theme.css"

const MySecretPage = (props) => {
    const toast = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [debouncedValue, setDebouncedValue] = useState('');
    const [dataService, setDataService] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [hideResult, setHideResult] = useState(false);
    const debounceDelay = 500;

    const [formData, setFormData] = useState({
        phone: '',
    });
    
    useEffect(() => {
        props.hideloader();
        ParserImage();
    });

    useEffect(() => {
        // Clear the timeout if searchTerm changes before debounceDelay
        const handler = setTimeout(() => {
            setDebouncedValue(searchTerm);
        }, debounceDelay);

        // Cleanup function to clear timeout if component unmounts or searchTerm changes
        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]); 
    
    useEffect(() => {
        if (debouncedValue) {
            axios
                .post(`${global.config.backend}/api/secretfindbyphone`, {
                        phone: searchTerm
                })
                .then((res) => {
                    setHideResult(true)
                    const data = res.data.data.map((item) => {
                        return {
                            code: item.id,
                            name: item.service
                        }
                    })

                    setDataService(data)
                })
                .catch((res) => {
                    console.log(res);
                    toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
                });
        }
    }, [debouncedValue]);

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        SpinnerLoading(true);
        
        if (selectedService){
            axios
                .post(`${global.config.backend}/api/secretfindbyid`, {
                    id: selectedService.code
                })
                .then((res) => {
                    SpinnerLoading(false);
                    if(res.data.status){
                        toast.current.show({ severity: 'success', detail: 'Detail Berhasil di kirim ke nomer tujuan' }); 
                        refresh()
                    }else{
                        toast.current.show({ severity: 'warn', detail: 'Gagal mengirim detail secret ke nomer tujuan' });
                    }
                })
                .catch((res) => {
                    console.log(res);
                    toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
                });
        }else{
            SpinnerLoading(false);
            toast.current.show({ severity: 'warn', detail: 'Layanan Harus di pilih' });
        }
    };

    const handleRequestUpdate = () => {
        SpinnerLoading(true);
        
        if (selectedService){
            axios
                .post(`${global.config.backend}/api/secretrequestupdate`, {
                    secretId: selectedService.code
                })
                .then((res) => {
                    SpinnerLoading(false);
                    if(res.data.status){
                        toast.current.show({ severity: 'success', detail: 'url form update Berhasil di kirim ke nomer tujuan' });
                        refresh()
                    }else{
                        toast.current.show({ severity: 'warn', detail: 'Gagal mengirim url form update ke nomer tujuan' });
                    }
                })
                .catch((res) => {
                    SpinnerLoading(false);
                    console.log(res);
                    toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
                });
        }else{
            SpinnerLoading(false);
            toast.current.show({ severity: 'warn', detail: 'Layanan Harus di pilih' });
        }
    };

    const refresh = () => {
        setFormData({})
        setSearchTerm('')
        setSelectedService(null)
        setDataService([])
        setHideResult(false)
    }

    return (
        <>
            <Toast ref={toast} />
            <section style={{
                backgroundImage: 'url(https://api-gateway.sampangkab.go.id/be-kominfo/sampanganimation/api/getimage/L2Fzc2V0cy91cGxvYWQvaW1hZ2VzL2JhY2tncm91bmQvYmdzc2QzLW1pbi5wbmc=)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
                height: '100%'
            }}></section>
            <section class="align-items-center d-flex h-100"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    background: 'transparent'
                }}>
                <div class="container-fluid">
                    <div className="row justify-content-center mb-3">
                        <img height="100"
                            src="/assets/upload/images/template_image/kominfo.png"
                            alt="logo" />
                    </div>
                    <h5 className="text-center mb-4">DINAS KOMINFO</h5>
                    <div class="row justify-content-center align-items-center d-flex  text-center">
                        <div class="col-12 col-md-4 col-lg-3">
                            <div class="card-body" 
                                style={{
                                    width: '100%',
                                    padding: 0
                                }}>
                                <form class="p-4 card shadow border-10" onSubmit={handleSubmit}>
                                    <p className="text-uppercase font-weight-bold h-2 text-dark" >My Secret</p>
                                    <div class="form-group">
                                        <input type="tel"
                                            name="phone"
                                            value={searchTerm}
                                            onChange={handleChange}
                                            class="form-control form-control-lg" placeholder="Nomor Hp" />
                                    </div>
                                    {hideResult && (
                                        <div class="form-group">
                                            <Dropdown value={selectedService} onChange={(e) => setSelectedService(e.value)} options={dataService} optionLabel="name"
                                                placeholder="Pilih Layanan" className="w-100" />
                                        </div>
                                    )}
                                    <div class="d-flex mb-2">
                                        {hideResult && (
                                            <React.Fragment>
                                                <button type="submit" class="btn btn-md btn-block text-white" style={{ background: 'linear-gradient(135deg,#04a,#05c,#04a,#04a,#002461)', marginTop: 0, marginRight: '5px'}}>
                                                    Kirim Detail
                                                </button>
                                                <button onClick={handleRequestUpdate} type="button" class="btn btn-md btn-block text-white" style={{ background: 'linear-gradient(135deg, rgb(255, 179, 71), rgb(252 164 39), rgb(255, 179, 71), rgb(255, 179, 71), rgb(255 150 0))', marginTop: 0, marginLeft: '5px' }}>
                                                    Update
                                                </button>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <span class="txt1">Punya Secret Baru ? <Link class="text-primary fw-bold ms-2" to="/mysecret/add" > Tambahkan di sini</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default MySecretPage;
